import { IComponentNode } from 'app/app/editor/index.functions';
import { alpha, Box } from '@mui/material';
import { useAppBuilderContext } from 'app/app/editor/context';
import { useElementIsActive } from './useElementIsActive';
import IconMi from 'components/common/icon/IconMi';
import { useMemo } from 'react';

export default function NodeNameLine({ node, componentUid }: { node: IComponentNode; componentUid?: string | null }) {
    const ctx = useAppBuilderContext();

    const componentName = node.type == 'container' ? 'container' : ctx.page.components[node.params.uid].component;

    const elementIsActive = useElementIsActive(componentUid, node.params?.uid);

    const icon = useMemo(() => {
        const allComponents = ctx.componentsMenu.flatMap((components) => components.components);
        return allComponents.find((item) => item.name === componentName)?.icon ?? null;
    }, [ctx.componentsMenu, componentName]);

    const title = useMemo(() => {
        if (node?.params?.attr?.title) return node.params.attr.title;
        if (node.params.uid === 'page') return 'Page';
        if (node.subtype === 'page_menu') return 'Menu Container';
        const allComponents = ctx.componentsMenu.flatMap((components) => components.components);
        return allComponents.find((item) => item.name === componentName)?.title ?? null;
    }, [ctx.componentsMenu, componentName, node, node.params?.uid, node.subtype, node.params?.attr?.title]);

    return (
        <Box
            onClick={() => ctx.editComponent({ uid: node.params?.uid })}
            sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, pb: '2px' }}
        >
            <Box
                sx={{
                    lineHeight: '13px',
                    color: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {icon && componentName !== 'container' && (
                    <IconMi
                        icon={icon}
                        sx={{
                            fontSize: '14px',
                            marginRight: '8px',
                            color: elementIsActive ? 'primary.main' : 'text.primary',
                            '&:hover': { color: 'primary.main' },
                        }}
                    />
                )}
                <Box
                    component={'span'}
                    sx={{
                        color: elementIsActive ? 'primary.main' : 'text.primary',
                    }}
                >
                    {title}
                </Box>
            </Box>
        </Box>
    );
}
